"use client";
import React from "react";

export default function ProjectOverview({ project }) {
  return (
    <section className="w-full pt-16 md:pt-[130px]">
      <div className="w-full mx-auto theme-container">
        <div className="grid items-center grid-cols-6 md:grid-cols-12">
          <div className="col-span-6">
            <h1 className="text-24 sm:text-34 leading-[55px] tracking-tight font-semibold text-white">
              Overview
            </h1>
            <p className="max-w-[533px] text-18 sm:text-24 leading-[40px] text-gray-300 mt-2.5 md:mt-3.5">
              {project?.overview}
            </p>
          </div>
          <div className="col-span-6 mt-5 md:mt-0">
            {project?.image ? (
              <div className="relative w-full h-full max-h-[400px] sm:max-h-[500px] rounded-2xl overflow-hidden group">
                {/* Main Hero Image (Thumbnail) */}
                <div className="block w-full h-full">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            ) : (
              /* Fallback if no main image, try first gallery image or placeholder */
              project?.images && project.images.length > 0 ? (
                <div className="relative w-full h-full max-h-[400px] sm:max-h-[500px] rounded-2xl overflow-hidden group">
                  <div className="block w-full h-full">
                    <img src={project.images[0]} alt={project.title} className="w-full h-full object-cover" />
                  </div>
                </div>
              ) : (
                <div className="w-full aspect-video bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center backdrop-blur-sm">
                  <span className="text-gray-400">No images available</span>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
